<template>
  <aside class="aside-menu" :class="{ open: value }" v-click-outside="close">
    <div class="ml-3 mt-4" @click="home">
      <div :class="logo ? 'side-menu-logo' : ''" :style="logo" />
    </div>

    <div
      class="btn-close d-flex align-items-center justify-content-center"
      @click="close"
    >
      <i class="icon-chevron-left" />
    </div>

    <div class="menu-items flex-fill mt-5">
      <menu-item
        v-for="(module, i) in modules"
        :key="i"
        class="mb-2"
        :module="module"
        :selectedItem="selectedItem"
        @selectItem="selectItem"
        @close="close"
      />

      <a
        v-if="externalLibraryUrl"
        class="external-library-item d-flex align-items-center px-3 py-2 mb-2"
        :href="externalLibraryUrl"
        target="_blank"
        rel="noopener noreferrer"
        @click="close"
      >
        <i class="icon-external-link" />
        <span class="label ml-3 pl-1">{{ externalLibraryLabel }}</span>
      </a>
    </div>

    <div v-if="communities.length" class="communities-section px-3 mt-3">
      <div class="divider mb-3" />
      <div class="section-label mb-2">Comunidades</div>
      <button
        v-for="community in communities"
        :key="community.id"
        class="community-link d-flex align-items-center px-2 py-2 mb-1"
        @click="openCommunity(community)"
      >
        <i class="icon-area mr-2" />
        <span class="label text-truncate">{{ community.name }}</span>
      </button>
    </div>

    <!-- <user-progress class="mx-2 mb-2 mt-4" /> -->

    <div v-if="socialMediaUrl.length" class="pt-3 mb-3" :class="`social-media`">
      <div class="divider mb-3" />
      <div class="ml-3">
        <div class="mb-2">
          {{ this.socialMediaUrl.length > 1 ? "Redes Sociais" : "Rede Social" }}
        </div>
        <a
          v-for="(url, i) in $setup.setup.social_media"
          v-show="url"
          :key="i"
          :class="`icon-${i} mr-3`"
          :href="url.includes('https://') ? url : `https://${url}`"
          target="_blank"
        />
      </div>
    </div>
  </aside>
</template>

<script>
import MenuItem from "@/components/MenuItem.vue";
// import UserProgress from "@/components/UserProgress.vue";
import ClickOutside from "vue-click-outside";
import { mapGetters, mapState } from "vuex";

export default {
  directives: {
    ClickOutside
  },
  components: { /* UserProgress, */ MenuItem },
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selectedItem: ""
    };
  },
  computed: {
    ...mapState("modules", ["modules"]),
    ...mapState("community", ["communities"]),
    ...mapGetters(["activeProductId"]),
    externalLibraryUrl() {
      const setup = this.$setup.setup;
      if (!setup || !setup.external_library_enabled) return "";
      const url = setup.external_library_url || "";
      return /^https?:\/\//i.test(url) ? url : "";
    },
    externalLibraryLabel() {
      return this.$setup.setup.external_library_label || "Biblioteca";
    },
    socialMediaUrl() {
      if (this.$setup.setup.social_media !== null) {
        return Object.values(this.$setup.setup.social_media).filter(
          item => item != ""
        );
      } else return [];
    },
    logo() {
      if (this.$setup.setup.logo || this.$setup.partnerLogo) {
        if (this.$setup.setup.logo)
          return `background-image: url(${this.$setup.setup.logo})`;
        return `background-image: url(${this.$setup.partnerLogo})`;
      }
      return false;
    }
  },
  methods: {
    selectItem(item) {
      if (item.id == this.selectedItem) {
        this.selectedItem = "";
      } else {
        this.selectedItem = item.id;
      }
    },
    openCommunity(community) {
      this.$emit("close");
      this.$router.push({ name: "community", params: { id: community.id } });
    },
    loadCommunities(productId) {
      if (!productId) {
        this.$store.commit("community/setCommunities", []);
        return;
      }
      this.$store.dispatch("community/listForArea", productId).catch(() => {});
    },
    home() {
      this.$emit("close");
      this.$router.push({ name: "home" });
    },
    close() {
      this.$emit("close");
    }
  },
  mounted() {
    this.loadCommunities(this.activeProductId);
  },
  watch: {
    value(val) {
      if (val == false) {
        this.selectedItem = "";
      }
    },
    activeProductId(productId) {
      this.loadCommunities(productId);
    }
  }
};
</script>

<style lang="scss">
.aside-menu {
  top: 0;
  left: -328px;
  width: 314px;
  bottom: 0;
  z-index: 8;
  display: flex;
  position: fixed;
  transition: all 0.3s;
  flex-direction: column;

  .menu-items {
    overflow: scroll;
    &::-webkit-scrollbar {
      display: none;
    }
  }

  .external-library-item {
    cursor: pointer;
    color: inherit;
    text-decoration: none;
    white-space: nowrap;
    i {
      font-size: 20px;
    }
    .label {
      font-size: 14px;
    }
    &:hover {
      text-decoration: none;
      opacity: 0.85;
    }
  }

  .communities-section {
    .section-label {
      font-size: 13px;
      font-weight: 600;
      opacity: 0.8;
    }

    .community-link {
      width: 100%;
      border: none;
      background: transparent;
      color: inherit;
      text-align: left;
      border-radius: 8px;
      cursor: pointer;

      i {
        font-size: 18px;
      }

      .label {
        font-size: 14px;
      }

      &:hover {
        opacity: 0.85;
        background: rgba(128, 128, 128, 0.12);
      }
    }
  }

  .btn-close {
    top: 28px;
    width: 28px;
    left: 300px;
    height: 28px;
    cursor: pointer;
    position: absolute;
    border-radius: 100%;
    i {
      font-size: 18px;
    }
  }

  &::-webkit-scrollbar {
    display: none;
  }

  &.open {
    left: 0;
    .btn-lock {
      display: flex;
    }
  }
  .side-menu-logo {
    max-width: 100%;
    width: auto;
    height: 80px;
    margin-right: 16px;
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
  }
}
</style>
